<div class="book-aggregated-component" id="book-aggregated-component">
  <div class="header-table">
    <div class="line">
      <div class="padding-number aggregate qtd">QTD.</div>
      <div class="padding-number aggregate sale">COMPRA</div>
      <div class="padding-number aggregate sale">VENDA</div>
      <div class="padding-number aggregate qtd last">QTD.</div>
    </div>
  </div>
  <div id="agGrid" class="flex-column table-book align" *ngIf="!loading">
    <table class="col-12 table-striped table-hovered table-body" *ngIf="rowPriceData?.length >= 0">
      <tbody>
        <tr *ngFor="let row of rowPriceData let index=index;">
          <td class="padding-number aggregate qtd">{{ row.qty_purchase | abbreviateNumber }}</td>
          <td class="aggressor aggregate buy cursor" (click)="openBillet('sell', row.purchase);">
            <currency-cell [price]="row.purchase" [changeBackground]="false"></currency-cell>
          </td>
          <td class="aggressor aggregate sell cursor" (click)="openBillet('buy', row.sale);">
            <currency-cell [price]="row.sale" [changeBackground]="false"></currency-cell>
          </td>
          <td class="padding-number aggregate qtd">{{ row.qty_sale | abbreviateNumber }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
